import axios from 'axios';
import store from '../redux/store/store';
const API_URL = import.meta.env.VITE_API_URL;

const authHeader = () => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return { headers: { Authorization: `Bearer ${userToken}` } };
};

const productSyncService = {
  // PlaceProductTrigger
  getTrigger: (userId) =>
    axios.get(`${API_URL}/PlaceProductTrigger?UserId=${userId}`, authHeader()),
  addTrigger: (data) =>
    axios.post(`${API_URL}/PlaceProductTrigger`, data, authHeader()),
  updateTrigger: (data) =>
    axios.put(`${API_URL}/PlaceProductTrigger`, data, authHeader()),

  // PlaceTriggerDefination
  getDefinations: (triggerId) =>
    axios.get(`${API_URL}/PlaceTriggerDefination?TriggerId=${triggerId}`, authHeader()),
  addDefination: (data) =>
    axios.post(`${API_URL}/PlaceTriggerDefination`, data, authHeader()),
  deleteDefination: (id) =>
    axios.delete(`${API_URL}/PlaceTriggerDefination`, { ...authHeader(), params: { id } }),

  // PlaceProductDefinationRule
  getRule: (definationId) =>
    axios.get(`${API_URL}/PlaceProductDefinationRule?DefinationId=${definationId}`, authHeader()),
  addRule: (data) =>
    axios.post(`${API_URL}/PlaceProductDefinationRule`, data, authHeader()),
  updateRule: (data) =>
    axios.put(`${API_URL}/PlaceProductDefinationRule`, data, authHeader()),
  deleteRule: (id) =>
    axios.delete(`${API_URL}/PlaceProductDefinationRule`, { ...authHeader(), params: { id } }),

  // PlaceProductTriggerLog (salt okunur, sayfalı)
  getLogs: (triggerId, page, pageSize) =>
    axios.get(
      `${API_URL}/PlaceProductTriggerLog?TriggerId=${triggerId}&Page=${page}&PageSize=${pageSize}`,
      authHeader()
    ),

  // Birleşik dropdown için lookup listeleri
  getMarketPlaces: () =>
    axios.get(`${API_URL}/MarketPlace?PageSize=200&Page=1`, authHeader()),
  getEcommercePlaces: () =>
    axios.get(`${API_URL}/EcommercePlace?PageSize=200&Page=1`, authHeader()),
};

export default productSyncService;
